module.exports = __webpack_public_path__ + "static/media/5.e3d8b3d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/5.png
// module id = 920
// module chunks = 0